export const leagueData = {
  name: 'a good time',
  id: '0910ef92f1cb4dc4a89aa073ab4ee8e8',
};

export const rounds: Array<{
  id: string;
  name: string;
  path: string;
}> = [
  {
    id: 'c897521fb1414bb8bcbc2b632f3592a5',
    name: 'Driving in a car at night',
    path: 'round-1.html',
  },
  {
    id: '767981eb6ee041eca3164aea46f58d01',
    name: 'Oh shit, we\'re at the climax now',
    path: 'round-2.html',
  },
  {
    id: 'd41c389f33314fb2a76b7bfa08e7caf0',
    name: 'Amigos. 朋友. ともだち',
    path: 'round-3.html',
  },
  {
    id: 'fdb4ef0bdd6e4220a97e705dedd30c38',
    name: 'Let\'s give Andy some violin ideas!',
    path: 'round-4.html',
  },
  {
    id: '648082d8de674f63b8293c1561bd6a32',
    name: 'Niche genre you feel only you listen to',
    path: 'round-5.html',
  },
  {
    id: '725db81aadc842eea702d4d35b9aa081',
    name: 'Stahp azn h8',
    path: 'round-6.html',
  },
  {
    id: '558a1ae6402b42f9ae6fcdc5dd1d8d9b',
    name: 'Embrace the Adventure',
    path: 'round-7.html',
  },
  {
    id: 'f58873db6b6f4f40bafbbe8ec319e67f',
    name: 'dEE eE EYe',
    path: 'round-8.html',
  },
  {
    id: '83d7a896dc4c4677b86c9340e9fc6ca3',
    name: 'Time to get lit',
    path: 'round-9.html',
  },
  {
    id: '00848cc61f5d44e2880eaba2b5f5f6ee',
    name: 'aural warfare (pt2 electric boogaloo)',
    path: 'round-10.html',
  },
  {
    id: 'c4bb47dfdb3a4be7b44acabd2bb7098a',
    name: 'Make me feel like I\’m in a toxic situationship again',
    path: 'round-11.html',
  },
  {
    id: 'b01289a874ea47babb5da65fdd676710',
    name: 'Hipster',
    path: 'round-12.html',
  },
  {
    id: '45d3e53eea514227a4a31e6bb19dc2c5',
    name: 'Best angst',
    path: 'round-13.html',
  },
  {
    id: '13567b47153a4b5880ef17c6352f8f3a',
    name: 'Beats to relax/study to',
    path: 'round-14.html',
  },
];
